import { render, staticRenderFns } from "./CarAssest.vue?vue&type=template&id=325808fa&scoped=true"
import script from "./CarAssest.vue?vue&type=script&lang=js"
export * from "./CarAssest.vue?vue&type=script&lang=js"
import style0 from "./CarAssest.vue?vue&type=style&index=0&id=325808fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325808fa",
  null
  
)

export default component.exports